import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VMain,[_c(VContainer,{attrs:{"id":"resources-container","fluid":"","tag":"section"}},[_c('base-material-card',{staticClass:"px-5 py-3",attrs:{"icon":"mdi-link-variant"}},[_c(VSimpleTable,[_c('tbody',[_c('tr',[_c('td',[_c('a',{attrs:{"href":(_vm.baseUrl + "docs/tilyet_bylaws_2022.pdf"),"target":"_blank"}},[_vm._v("Tilyet Benevolence Fund Bylaws")])])])])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }